import { ArrowUpRight, ShoppingBag } from "lucide-react";
import type { Locale } from "../i18n";
import { discoveryContent } from "./content";
import { polishContent } from "./polishContent";

export function ShopIntro({ locale }: { readonly locale: Locale }): React.JSX.Element {
  const t = discoveryContent(locale), copy = polishContent[locale];
  return <section className="dc-shop-intro" aria-labelledby="shop-heading">
    <div className="dc-shop-intro-copy">
      <span className="dc-shop-mark" aria-hidden="true"><ShoppingBag size={22} strokeWidth={1.5} /></span>
      <h1 id="shop-heading">{t.shopTitle}</h1>
      <p>{copy.shopIntro}</p>
      <a className="dc-shop-explore" href="#shop-products">{copy.browse}<ArrowUpRight size={18} aria-hidden="true" /></a>
    </div>
    <a className="dc-shop-mood" href={`/discover?lang=${locale}&space=condo`}>
      <img src="/interiors/hero-living.webp" width="1536" height="1024" alt="" fetchPriority="high" />
      <div><span>{copy.roomIdeas}</span><ArrowUpRight size={22} aria-hidden="true" /></div>
      <small>{t.concept}</small>
    </a>
  </section>;
}
